import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlowDataGuard } from './guards/flow-data.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'aviso',
    pathMatch: 'full'
  },
  {
    path: 'aviso',
    loadChildren: () =>
      import('./pages/aviso/aviso.module').then((m) => m.AvisoPageModule)
  },
  {
    path: 'datos',
    canActivate: [FlowDataGuard],
    loadChildren: () =>
      import('./pages/datos/datos.module').then((m) => m.DatosPageModule)
  },
  {
    path: 'confirmacion',
    canActivate: [FlowDataGuard],
    loadChildren: () =>
      import('./pages/confirmacion/confirmacion.module').then(
        (m) => m.ConfirmacionPageModule
      )
  },
  {
    path: 'resultado/:outcome',
    canActivate: [FlowDataGuard],
    loadChildren: () =>
      import('./pages/resultado/resultado.module').then(
        (m) => m.ResultadoPageModule
      )
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
